import BaseTag from "./BaseTag.vue";

export * from "./BaseTag.vue";
export default BaseTag;
